module.exports = new __parcel__URL__("delivery.a382aca2.webp").toString();